document.addEventListener('DOMContentLoaded', function() {
  const chartContainer = document.getElementById('chart-container');
  const catButtons = document.querySelectorAll('.button-group button');
  const unitButtons = document.querySelectorAll('.unit-btn');
  const unitSwitch = document.querySelector('.unit-switch');
  let currentUnit = 'in';

  function applyUnit() {
    if (!chartContainer) return;
    chartContainer.querySelectorAll('[data-in],[data-cm]').forEach(function(cell) {
      const val = cell.getAttribute('data-' + currentUnit);
      if (val) {
        cell.textContent = val;
      }
    });
  }

  function loadSection(sectionId) {
    if (!chartContainer) return;

    chartContainer.style.opacity = 0;

    setTimeout(function () {
      fetch(`?section_id=${sectionId}`)
        .then(function(response) { return response.text(); })
        .then(function(data) {
          chartContainer.innerHTML = data;
          chartContainer.style.opacity = 1;
          // After new HTML is injected, apply current unit
          applyUnit();
        });
    }, 200); // match your transition speed
  }

  // Initial load for active button
  const activeButton = document.querySelector('.button-group button.active');
  if (activeButton) {
    const sectionId = activeButton.getAttribute('data-section');
    loadSection(sectionId);
  }

  // Click handlers for category buttons (Tops / Bras / Bottoms)
  catButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      catButtons.forEach(function(btn) { btn.classList.remove('active'); });
      this.classList.add('active');

      const sectionId = this.getAttribute('data-section');
      loadSection(sectionId);
    });
  });

  // Click handlers for unit buttons (in / cm)
function updateToggleWrapper() {
  const wrapper = document.querySelector('.unit-toggle');
  if (!wrapper) return;
  wrapper.classList.toggle('unit-toggle--cm', currentUnit === 'cm');
  wrapper.classList.toggle('unit-toggle--in', currentUnit === 'in');
}

if (unitButtons.length) {
  unitButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      unitButtons.forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');

      currentUnit = this.getAttribute('data-unit') || 'in';
      applyUnit();          // your existing function that swaps data-in/data-cm
      updateToggleWrapper(); // move the dot
    });
  });

  // Set initial state based on which button is active on load
  //const initial = document.querySelector('.unit-btn.active');
  //if (initial) {
  //  currentUnit = initial.getAttribute('data-unit') || 'in';
  //  updateToggleWrapper();
  //}
}
if (unitSwitch) {
  unitSwitch.addEventListener('click', function () {
    currentUnit = currentUnit === 'in' ? 'cm' : 'in';

    // Update buttons
    unitButtons.forEach(btn => {
      btn.classList.toggle('active', btn.getAttribute('data-unit') === currentUnit);
    });

    updateToggleWrapper();
    applyUnit();
  });
}

// Initialize
updateToggleWrapper();
});
